import {AbstractStep} from "./AbstractStep";
import {PersonaliaModel} from "./PersonaliaModel";
import personaliaHtml from './personalia.html?raw';

export let template = personaliaHtml;

export class viewModel extends AbstractStep<PersonaliaModel> {
}